export enum UserOverviewType {
  LEAVES_TODAY,
  VACATION,
  OVERTIME,
  BIRTHDAY,
}
